import { t } from "@/i18n-js/instance";
import type { FilterType } from "@circle-react/components/Courses/Directory/types";
import { useAddCourse } from "@circle-react/components/Courses/useAddCourse";
import { MessagePanel } from "@circle-react/components/Events/MessagePanel";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { Button } from "@circle-react-uikit/Button";

interface EmptyStateProps {
  filter: FilterType;
}

export const EmptyState = ({ filter }: EmptyStateProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const addCourse = useAddCourse();

  if (filter === "joined") {
    return (
      <MessagePanel
        title={t("courses.directory.empty.joined_title")}
        description={t("courses.directory.empty.joined_description")}
      />
    );
  }

  if (isAdmin) {
    return (
      <MessagePanel
        title={t("courses.directory.empty.admin_title")}
        description={t("courses.directory.empty.admin_description")}
      >
        <Button variant="primary" className="mt-4" onClick={addCourse}>
          {t("courses.create_course")}
        </Button>
      </MessagePanel>
    );
  }

  return (
    <MessagePanel
      title={t("courses.directory.empty.member_title")}
      description={t("courses.directory.empty.member_description")}
    />
  );
};
